import { render, staticRenderFns } from "./rearrange-list.vue?vue&type=template&id=0f09a082&"
import script from "./rearrange-list.vue?vue&type=script&lang=ts&"
export * from "./rearrange-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports